var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { to: "modal" } },
    [
      _c("transition", { attrs: { "leave-active-class": "duration-200" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show",
              },
            ],
            staticClass:
              "fixed top-0 inset-x-0 px-4 pt-6 sm:px-0 sm:flex sm:items-top sm:justify-center",
          },
          [
            _c(
              "transition",
              {
                attrs: {
                  "enter-active-class": "ease-out duration-300",
                  "enter-class": "opacity-0",
                  "enter-to-class": "opacity-100",
                  "leave-active-class": "ease-in duration-200",
                  "leave-class": "opacity-100",
                  "leave-to-class": "opacity-0",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show",
                      },
                    ],
                    staticClass: "fixed inset-0 transform transition-all",
                    on: { click: _vm.close },
                  },
                  [
                    _c("div", {
                      staticClass: "absolute inset-0 bg-gray-500 opacity-75",
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "transition",
              {
                attrs: {
                  "enter-active-class": "ease-out duration-300",
                  "enter-class":
                    "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-active-class": "ease-in duration-200",
                  "leave-class": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to-class":
                    "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show",
                      },
                    ],
                    staticClass:
                      "bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full",
                    class: _vm.maxWidthClass,
                  },
                  [_vm._t("default")],
                  2
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }